import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { pageContext } from 'ctm-util-functions';
import { RadioFilter } from 'ctm-components';

const isComprehensiveOnlyBrand = (theme) => {
    const comprehensiveOnlyBrandList = ['choo'];
    return comprehensiveOnlyBrandList.includes(theme);
};

/**
 * CoverType Radio Button Refine Results Filter
 * @returns {Node} RadioFilter RadioFilter component
 */
class _CoverTypeFilter extends PureComponent {

    constructor(props) {
        super(props);

        // Additional Actions set onClick for a Radio Filter
        this.extraActionsFunction = this.getExtraActionsFunction;
    }

    /**
     * Sets requestedExcess filter values and adds action to staged filter actions.
     * This is done to support RadioFilter additional actions to be set onClick.
     * @param  {Object} e - the function event object.
     */
    getExtraActionsFunction = (e) => {
        const { dispatch } = this.props;
        if (e.target.value === 'TPFT' || e.target.value === 'TPPD') {
            dispatch({
                type: 'SET_FILTER_VALUE',
                filter: 'requestedExcess',
                filterStaged: true,
                filterValue: '600'
            });
            dispatch({
                type: 'SET_FILTER_ACTION',
                resultsStateKey: 'filters.requestedExcess',
                resultsStagedStateKey: 'helpers.filters.requestedExcess',
                formStateKey: 'coverDetail.requestedExcess'
            });
        } else if (e.target.value === 'COMPREHENSIVE') {
            dispatch({
                type: 'SET_EXCESS_BY_STATE_FILTER',
                filter: 'requestedExcess',
                filterStaged: true
            });
            dispatch({
                type: 'SET_FILTER_ACTION',
                resultsStateKey: 'filters.requestedExcess',
                resultsStagedStateKey: 'helpers.filters.requestedExcess',
                formStateKey: 'coverDetail.requestedExcess'
            });
        }
    };

    /**
     * Render the coverType filter for results
     * @returns {Node} The coverType RadioFilter component
     */
    render = () => {
        const radioFilterProps = this.props;
        return !isComprehensiveOnlyBrand(pageContext.getProps().everestTheme)
            && <RadioFilter {...radioFilterProps} extraActionsFunction={this.extraActionsFunction} />;
    };

}

_CoverTypeFilter.propTypes = {
    filterProps: PropTypes.shape({
        filter: PropTypes.string,
        label: PropTypes.string,
        showCustomInput: PropTypes.bool,
        customInputIdentifier: PropTypes.string,
        customInputSuffix: PropTypes.string,
        showUpdateButton: PropTypes.bool,
        fetchNewResults: PropTypes.bool.isRequired,
        resultsStagedStateKey: PropTypes.string.isRequired,
        resultsStateKey: PropTypes.string.isRequired,
        formStateKey: PropTypes.string.isRequired,
        initialFormStateKey: PropTypes.string,
        UIComponent: PropTypes.string,
        values: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string,
                label: PropTypes.string,
                default: PropTypes.bool
            })
        ).isRequired
    }).isRequired,
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
    labelCssClass: PropTypes.string,
    rules: PropTypes.object,
    selectedValue: PropTypes.string,
    customValue: PropTypes.string,
    dispatch: PropTypes.func
};

/**
 * Map state to our component props
 * @param {Object} state - the application state
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = (state) => {
    const form = quoteFormSelector(state);
    const marketValue = form.getIn(['coverDetail', 'vehicle', 'marketValue']);
    const verticalName = state.getIn(['page', 'vertical']);
    const ignoreIsOriginalValueSelected = verticalName === 'car-insurance';
    return {
        ignoreIsOriginalValueSelected
    };
};

const CoverTypeFilter = connect(mapStateToProps)(_CoverTypeFilter);
export { _CoverTypeFilter, CoverTypeFilter };
